/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { AuthGuard } from '../auth.guard';

import { ContactsComponent } from '../contacts/contacts.component';

export const contactRouterConfig = [
  {
    path: 'contacts',
    component: ContactsComponent,
    canActivate: [AuthGuard],
    data: { role: 'contributor', title: 'Contacts', uiTitle: 'Contacts' }
  }
];



// WEBPACK FOOTER //
// ./client/app/routes/contact.routes.ts